var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrophy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.8333 0.479858H4.16667C1.8691 0.479858 0 2.34896 0 4.64652C0 6.73027 1.5391 8.45654 3.53923 8.7607C4.02039 10.6853 5.33712 12.2773 7.08333 13.132V15.7252C5.86324 16.221 5 17.4173 5 18.8132V19.6465C5 20.1065 5.37333 20.4799 5.83333 20.4799H14.1667C14.6267 20.4799 15 20.1065 15 19.6465V18.8132C15 17.4173 14.1368 16.221 12.9167 15.7252V13.132C14.6629 12.2773 15.9796 10.6853 16.4608 8.7607C18.4609 8.45654 20 6.73027 20 4.64652C20 2.34896 18.1309 0.479858 15.8333 0.479858ZM1.66667 4.64652C1.66667 3.5603 2.36369 2.63643 3.33333 2.2924V7.00065C2.36369 6.65662 1.66667 5.73275 1.66667 4.64652ZM6.66667 18.8132C6.66667 17.894 7.41414 17.1465 8.33333 17.1465H11.6667C12.5859 17.1465 13.3333 17.894 13.3333 18.8132H6.66667ZM11.25 15.4799H8.75V13.6915C9.15548 13.769 9.57255 13.8132 10 13.8132C10.4274 13.8132 10.8445 13.769 11.25 13.6915V15.4799ZM10 12.1465C7.24284 12.1465 5 9.90369 5 7.14652V2.14653H15V7.14652C15 9.90369 12.7572 12.1465 10 12.1465ZM16.6667 7.00065V2.2924C17.6363 2.63643 18.3333 3.5603 18.3333 4.64652C18.3333 5.73275 17.6363 6.65662 16.6667 7.00065Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5003 3.81319C12.0403 3.81319 11.667 4.18652 11.667 4.64652V7.14652C11.667 8.06571 10.9195 8.81319 10.0003 8.81319C9.54032 8.81319 9.16699 9.18652 9.16699 9.64652C9.16699 10.1065 9.54032 10.4799 10.0003 10.4799C11.8383 10.4799 13.3337 8.98449 13.3337 7.14652V4.64652C13.3337 4.18652 12.9603 3.81319 12.5003 3.81319Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0 0.479858)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrophy);
export default __webpack_public_path__ + "static/media/trophy.8ca45cd4.svg";
export { ForwardRef as ReactComponent };